// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};